

















































import { Component, Prop, PropSync } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { filter } from 'lodash';
import {
  PartnersApi, DocumentRequest, PresignedurlApi,
} from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import Dropzone from '@/components/Form/FileUploadForm/Dropzone/index.vue';
import SampleDocument from '@/components/Form/FileUploadForm/SampleDocument/index.vue';
import DocumentsList from '@/components/Form/FileUploadForm/DocumentsList/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import FileUtil from '@/util/FileUtil';
import ToastModule from '@/store/modules/toast';
import Axios from 'axios';
import PermissionMixin from '../../../../mixins/PermissionMixin';

@Component({
  components: {
    SampleDocument,
    DocumentsList,
    Dropzone,
    TextButton,
  },
})
export default class Documents extends mixins(FileUtil, PermissionMixin) {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @PropSync('documents', {}) documentsSync!: any;

  @Prop({}) file!: any;

  @Prop({}) uploadHeadline!: string;

  @Prop({}) listHeadline!: string;

  @Prop({}) fileHeadline!: string;

  @Prop({}) optinalHeadline!: boolean;

  @Prop({}) fileUrl!: string;

  @Prop({}) documentType!: string;

  @Prop({}) partnerID!: string;

  @Prop({}) archiveProps!: string;

  @Prop({}) expiryValue!: string;

  public loading: boolean = false;

  get documentsFiles() {
    return filter(
      this.documentsSync,
      doc => doc.type === this.documentType,
    );
  }

  public onUpload() {
    this.dialogSync = true;
  }

  public async onOptionDelete(document: any) {
    try {
      const documentID = document.id;
      const partnerID = document.partnerId;
      const api = new PartnersApi(AppModule.apiConfig);
      const data = await api.deletePartnerDocument(partnerID, documentID as string);
      const docs = await api.getPartnerDocuments(partnerID);
      this.documentsSync = docs.data.documents;
    } catch {
      //
    }
    this.loading = false;
  }

  public async onDone(documents: any) {
    try {
      this.loading = true;
      const presignedApi = new PresignedurlApi(AppModule.apiConfig);
      const api = new PartnersApi(AppModule.apiConfig);
      await Promise.all(documents.map(async (doc: any) => {
        const response = await presignedApi.presignedUrl(doc.name, doc.type);
        const { data: { preSignedUrl, getUrl } } = response as any;
        const url = preSignedUrl;
        await Axios.put(url, doc.file);
        const documentData: DocumentRequest = {
          documentName: doc.name,
          documentType: this.documentType,
          url: getUrl,
        };
        return api.postPartnerDocument(this.partnerID, documentData);
      }));
      const doc = await api.getPartnerDocuments(this.partnerID);
      const docs: any = doc.data.documents;
      this.documentsSync = docs;
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message,
          timeout: 5000,
        });
      }
    }
    this.loading = false;
  }

  public async postPartnerDocumnets(id: string, documentData: DocumentRequest) {
    try {
      const api = new PartnersApi(AppModule.apiConfig);
      const data = await api.postPartnerDocument(this.partnerID, documentData);
    } catch (error) {
      console.log('err', error);
    }
  }

  public async onPartnerDocument(partnerID: string) {
    try {
      this.loading = true;
      const api = new PartnersApi(AppModule.apiConfig);
      const docs = await api.getPartnerDocuments(partnerID);
      this.documentsSync = docs.data.documents;
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message,
          timeout: 5000,
        });
      }
    }
    this.loading = false;
  }

  get role() {
    return UserModule.currentRole || 'no role assigned';
  }
}
